import React, { useMemo } from "react"
import { useSelector } from "react-redux"

import { IRedux } from "../../services/types"
import AddUser from "./addUser/addUser"
import AddCompany from "./addCompany/addCompany"
import Confirmation from "./confirmation"
import Dates from "./dates"
import FormStep from "./form"

const Steps = () => {
  const settings = useSelector((state: IRedux) => state.settings?.extended)
  const event = useSelector((state: IRedux) => state.event)
  const { stepId } = useSelector((state: IRedux) => state.inscription)

  const steps = useMemo(() => {
    const array = [
      {
        label: "Choisir un nouveau participant",
        component: <AddUser />
      },
      {
        label: "Choisir une organisation",
        component: <AddCompany />
      }
    ]

    if (settings?.formId)
      array.push({
        label: "Remplir ce formulaire",
        component: <FormStep />
      })

    if (event.EventDays.length > 1)
      array.push({
        label: "Choisir vos dates",
        component: <Dates />
      })

    return [
      ...array,
      {
        label: "Inscription terminée",
        component: <Confirmation />
      }
    ]
  }, [event.EventDays.length, settings])

  const getComponentFromCurrentStep = () => {
    const currentStep = steps.find((s, index) => {
      const i = index + 1
      return i === stepId
    })
    return currentStep && currentStep.component
  }

  return (
    <div>
      <ul className="steps is-medium">
        {steps.map(({ label }, index) => {
          const i = index + 1
          return (
            <li
              className={`step-item ${stepId > i &&
                "is-completed is-success"} ${stepId === i &&
                "is-active"} ${stepId === steps.length &&
                "is-completed is-success"}`}
              key={label}
            >
              <div className="step-marker">{i}</div>
              <div className="step-details">
                <p className="step-title">Étape {i}</p>
                <p>{label}</p>
              </div>
            </li>
          )
        })}
      </ul>
      {getComponentFromCurrentStep()}
    </div>
  )
}

export default Steps
